<template>
  <nav class="navbar navbar-vertical fixed-left navbar-light navbar-expand-md bg-white" id="sidenav-main"
    :class="getNavClasses()">
    <div class="container-fluid">
      <div class="sidenav-header d-flex align-items-center">
        <router-link v-if="$sidebar.showSidebar" class="navbar-brand" to="/">
          <img src="static/img/brand/name_only.png" class="navbar-brand-img logo" alt="..." />
        </router-link>
        <!--Toggler-->
        <div :class="$sidebar.showSidebar ? 'ml-auto' : ''">
          <a type="button" v-on:click="handleSidebarShowButton">
            <i class="bi bi-x-lg fa-2x" v-if="$sidebar.showSidebar"></i>
            <i class="bi bi-list fa-2x" v-else></i>
          </a>

          <!-- <navbar-toggle-button @click="showSidebar" target="sidenav-collapse-main" :toggled="true">
            <span class="navbar-toggler-icon"></span>
          </navbar-toggle-button> -->
        </div>
      </div>

      <slot name="mobile-right">
        <ul class="nav align-items-center d-md-none">
          <!-- <base-dropdown class="nav-item" position="right">
            <template v-slot:title>
              <a
                class="nav-link nav-link-icon"
                href="#"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="ni ni-bell-55"></i>
              </a>
            </template>

            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#">Something else here</a>
          </base-dropdown>-->
          <li class="nav-item dropleft">
            <div class="media align-items-center nav-link pr-0 dropdown" data-toggle="dropdown" data-display="static"
              aria-expanded="false">
              <span class="avatar avatar-sm rounded-circle">
                <i class="bi bi-person-circle fa-2x"></i>
                <!--
              <img
                alt="Image placeholder"
                src="static/img/theme/team-4-800x800.jpg"
              /> TBD: Set image???-->
              </span>
              <div class="media-body ml-2 d-none d-lg-block">
                <span class="mb-0 text-sm font-weight-bold">{{ username }}</span>
              </div>
            </div>
            <div class="dropdown-menu dropdown-menu-lg-right">
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">{{ $t('dashboard_layout.userOverlayBoxTitle', { name: username }) }}</h6>
              </div>
              <router-link to="/account" class="dropdown-item">
                <i class="ni ni-single-02"></i>
                <span>{{ $t('dashboard_layout.profile') }}</span>
              </router-link>
              <!--<router-link to="/profile" class="dropdown-item">
            <i class="ni ni-settings-gear-65"></i>
            <span>Settings</span>
          </router-link>
          <router-link to="/profile" class="dropdown-item">
            <i class="ni ni-calendar-grid-58"></i>
            <span>Activity</span>
          </router-link>
          <router-link to="/profile" class="dropdown-item">
            <i class="ni ni-support-16"></i>
            <span>Support</span>
          </router-link> -->
              <div class="dropdown-divider"></div>
              <a v-on:click="logout" class="dropdown-item">
                <i class="ni ni-user-run"></i>
                <span>{{ $t('dashboard_layout.logOut') }}</span>
              </a>

            </div>
          </li>
        </ul>
      </slot>
      <slot></slot>

      <!-- responsive menu header -->
      <div v-show="$sidebar.showSidebar" class="collapse navbar-collapse show" id="sidenav-collapse-main"
      :class="$isMobile()?'navbar-uncollapsed-responsive':''">
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img src="static/img/brand/name_only.png" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button @click="closeSidebar"></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"> </slot>
        </ul>

      </div>
    </div>
  </nav>
</template>
<script>
import NavbarToggleButton from "@/components/NavbarToggleButton";

export default {
  name: "sidebar",
  components: {
    NavbarToggleButton,
  },
  props: {
    logo: {
      type: String,
      default: "static/img/brand/name_only.png",
      description: "Sidebar app logo",
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
  },
  provide() {
    return {
      sidebarShow: false,
      autoClose: this.autoClose,
    };
  },
  methods: {
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
    logout() {
      localStorage.removeItem('user');

      this.$router.push('/login')
    },
    handleSidebarShowButton() {
      if (!this.sidebarShow) {
        this.sidebarShow = true;
        this.showSidebar()
      } else {
        this.sidebarShow = false;
        this.closeSidebar()
      }
    },
    onMouseLeave() {
      if (!this.sidebarShow) {
        this.closeSidebar()
      }
    },
    getNavClasses(){
      if (!this.$isMobile()){
        return (this.$sidebar.showSidebar) ? 'navbar-uncollapsed' : 'navbar-collapsed'
      }
      return ''
      
    }
  },
  beforeUnmount() {
    if (!this.sidebarShow) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
.logo {
  width: 100%;
  height: 300px;
}

.navbar-collapsed {
  position: absolute;
  display: inline-block;
}

.navbar-uncollapsed {
  overflow: hidden;
  z-index: 999 !important;
}

.navbar-uncollapsed-responsive {
  position: fixed;
  overflow: hidden;
  z-index: 999 !important;
}

</style>
